module.exports = __webpack_public_path__ + "img/indexbg.fa31a4a2.png";